import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { Form } from "react-bootstrap";
import VehicleInfoViewModel from "viewModels/common/vehicleInfoViewModel";
import LicensePlateInput from "./licensePlateInput";
import { DataTestIds } from "../../../data-test-constants";

const LicensePlateInputWithConfirmation: FunctionComponent<{
  vm: VehicleInfoViewModel;
  errorMessage?: string;
  context?: "new" | "old";
}> = observer(({ vm, errorMessage, context }) => {
  const translate = (translateKey?: string) => (code: string) =>
    vm.localizationService.translateAttribute(translateKey ? `orderItem.${translateKey}` : "orderItem", code);

  if (!vm.item) {
    return null;
  }

  return (
    <Form.Row className="align-items-baseline">
      <LicensePlateInput
        id={DataTestIds.LICENSE_PLATE_INPUT}
        target={vm.item}
        property="licensePlate"
        fixedLength={vm.config.fixedLicensePlateSize}
        maxLength={vm.config.maxLicensePlateSize}
        translate={translate(context)}
        originalLicensePlate={vm.oldLicensePlate}
        locale={vm.localizationService.locale}
        countryCode={vm.countryCode}
        countryId={vm.item.countryId}
        disablePaste={true}
        errorMessage={errorMessage}
      />
      <LicensePlateInput
        id={DataTestIds.LICENSE_PLATE_CONFIRMATION_INPUT}
        target={vm.item}
        property="_licensePlateConfirmation"
        fixedLength={vm.config.fixedLicensePlateSize}
        maxLength={vm.config.maxLicensePlateSize}
        translate={translate(context ? `${context}.again` : "again")}
        originalLicensePlate={vm.oldLicensePlate}
        locale={vm.localizationService.locale}
        countryCode={vm.countryCode}
        countryId={vm.item.countryId}
        disablePaste={true}
        tooltip={false}
      />
    </Form.Row>
  );
});

export default LicensePlateInputWithConfirmation;
